import { motion } from 'framer-motion'
import { noop } from '../../../utils'
import { useAnalyticContext, usePlayerContext } from '../../../hooks'
import { transitionTemplate } from '../../../constants/constants'

export const InteractiveLink = (props) => {
  const { interactiveItem, onInteractivityFinished } = props
  const { pauseHandler } = usePlayerContext()
  const { playerBounding } = usePlayerContext()
  const { analyticCollector } = useAnalyticContext()

  const { link: href } = interactiveItem.getActionStrategy()

  const onClickHandler = () => {
    window.open(href, '_blank', 'noreferrer noopenner')
    pauseHandler()
    analyticCollector.setClick()
    onInteractivityFinished(noop, true)
  }

  const { object, getElementStyles } = interactiveItem

  const elementStyles = getElementStyles(playerBounding, object)

  return (
    <motion.button
      style={{ cursor: 'pointer', ...elementStyles }}
      type="button"
      {...transitionTemplate}
      onClick={onClickHandler}
      className="interactive-element-focusable"
    >
      <a
        href={href}
        tabIndex={-1}
        target="_blank"
        rel="noreferrer noopenner"
        style={{ top: 0, left: 0, bottom: 0, right: 0, position: 'absolute' }}
      >
        <span className="sr-only">Link</span>

        {/* for a11y purpose there should be added some text that describes a link's target */}
      </a>
    </motion.button>
  )
}
